import { height } from '~/app/d3charts/utils/common'
import * as d3 from 'd3'
import 'd3-scale'

const tooltipLineColor = 'dark'
const tooltipContainerCss = 'text-neutral-000 rounded-1 label-1'

export default class Tooltip {
  constructor(chart, dataSets, xScale, yAxisUnit) {
    this.tooltip = d3.select('#tooltip')
    this.tooltipLine = chart.append('line')
    this.dataSets = dataSets
    this.xScale = xScale
    this.yAxisUnit = yAxisUnit
  }

  removeTooltip() {
    if (this.tooltip) this.tooltip.style('display', 'none')
    if (this.tooltipLine) this.tooltipLine.attr('stroke', 'none')
  }

  drawTooltip(event) {
    const year = this.fetchYear(event)
    let filteredDataSet = []

    this.dataSets.map(dataSet => {
      const filtered = dataSet.data.filter(item => item.year === year)[0]

      if (filtered) {
        let roundedValue = Math.round(filtered.value * 10) / 10
        filteredDataSet.push({ name: dataSet.name, value: roundedValue })
      }
    })

    this.drawTooltipLine(year)

    this.tooltip
      .html(year)
      .style('display', 'block')
      .classed(tooltipContainerCss, true)
      .style('left', event.pageX + 20 + 'px')
      .style('top', event.pageY - 20 + 'px')
      .selectAll()
      .data(filteredDataSet)
      .enter()
      .append('div')
      .html(data => `${data.name.replaceAll('_', ' ')}: ${data.value} ${this.yAxisUnit}`)
  }

  drawTooltipLine(year) {
    this.tooltipLine
      .attr('stroke', tooltipLineColor)
      .attr('x1', this.xScale(year))
      .attr('x2', this.xScale(year))
      .attr('y1', 0)
      .attr('y2', height)
  }

  fetchYear() {
    const xMouseCoordinate = d3.pointer(event)[0]
    const domain = this.xScale.domain()
    const range = this.xScale.range()
    const rangePoints = d3.range(range[0], range[1], this.xScale.step())

    return domain[d3.bisect(rangePoints, xMouseCoordinate) - 1]
  }
}
